import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: открыт балун (карточка) по пину на карте проектов.
 */
export function trackMapBalloonOpen(newbuildingId: string): void {
  ca('eventSite', {
    action: 'show',
    category: 'Promo',
    label: 'project_map_pin',
    name: 'oldevent',
    products: [
      createDeveloperProduct({
        extra: {
          items: [
            {
              id: newbuildingId,
              offerType: 'newbuilding_id',
            },
          ],
        },
      }),
    ],
  });
}
